import { useLoaderData } from "react-router";
import SimpleFormPage from "../common/SimpleFormPage";
import DpiTypeFields from "./DpiTypeFields";

export default function EditDpiType() {
  const data = useLoaderData();
  const loadFn = (form) =>
    form.setFieldsValue(data);

  return (
    <SimpleFormPage title="Modifica categoria DPI" loadFn={loadFn}>
      <DpiTypeFields />
    </SimpleFormPage>
  );
}
